(function (Cobalt) {
    var NavigationLists = /** @class */ (function () {
        function NavigationLists() {
        }
        NavigationLists.EnableResponsiveness = function (elementWithOverflowSelector, unorderedListSelector, listItemsSelector, mobileBreakWidth, includeDesktopSupport) {
            ///<summary>Enable a mobile-friendly view of an unordered list. Certain mark-up is required.</summary>
            ///<param name="elementWithOverflowSelector">The jQuery selector for the element with the overflow: hidden style applied</param>
            ///<param name="unorderedListSelector">The jQuery selector for the unordered list</param>
            ///<param name="listItemsSelector">The jQuery selector for the unordered list's list items</param>
            ///<param name="mobileBreakWidth">When the window width hits this value, it will break into the mobile view</param>
            ///<param name="includeDesktopSupport">Including desktop support enables mobile scroll functionality for very large lists
            /// that wrap on desktop views</param>
            var _this = this;
            // get all jQuery objects from the selectors being passed in
            this.selectedListItem = $(listItemsSelector + ".selected");
            this.elementWithOverflow = $(elementWithOverflowSelector);
            this.unorderedList = $(unorderedListSelector);
            this.listItems = $(listItemsSelector);
            this.enableDesktopSupport = includeDesktopSupport;
            this.scrollbarWidth = 20;
            //Gets the width now so we dont call it 5 times through the init.
            var elementWithOverflowWidth = this.elementWithOverflow.width();
            this.handleScrollEvent(this.elementWithOverflow, this.scrollbarWidth, elementWithOverflowWidth);
            this.registerRightArrowHandler(this.elementWithOverflow, elementWithOverflowWidth);
            this.registerLeftArrowHandler(this.elementWithOverflow, elementWithOverflowWidth);
            if ($("body").hasClass("responsive-disabled")) {
                this.setULWidth(this.unorderedList, this.listItems, this.scrollbarWidth, mobileBreakWidth);
                this.handleArrows(this.elementWithOverflow, this.scrollbarWidth, elementWithOverflowWidth);
                this.centerListItem(this.elementWithOverflow, this.listItems, this.selectedListItem);
                return;
            }
            // ReSharper disable once UnusedLocals
            window.onresize = function (event) {
                _this.setULWidth(_this.unorderedList, _this.listItems, _this.scrollbarWidth, mobileBreakWidth);
                _this.handleArrows(_this.elementWithOverflow, _this.scrollbarWidth, _this.elementWithOverflow.width());
                _this.centerListItem(_this.elementWithOverflow, _this.listItems, _this.selectedListItem);
            };
            this.setULWidth(this.unorderedList, this.listItems, this.scrollbarWidth, mobileBreakWidth);
            this.handleArrows(this.elementWithOverflow, this.scrollbarWidth, elementWithOverflowWidth);
            this.centerListItem(this.elementWithOverflow, this.listItems, this.selectedListItem);
        };
        NavigationLists.setULWidth = function ($unorderedList, $listItems, scrollbarWidth, mobileBreakWidth) {
            ///<summary>Calculates the width of the UL by adding up the width of the list items</summary>
            ///<param name="unorderedList">The jQuery object for the unordered list</param>
            ///<param name="listItems">The jQuery for the unordered list's list items</param>
            ///<param name="scrollbarWidth">The width of the scrollbar</param>
            ///<param name="mobileBreakWidth">When the window width hits this value, it will break into the mobile view</param>
            if (window.innerWidth <= mobileBreakWidth || this.enableDesktopSupport) {
                var width = 0;
                $listItems.each(function (i, li) {
                    width += $(li).outerWidth(true);
                });
                // The scrollbar width is added as padding to prevent issues on mobile
                $unorderedList.width(width + scrollbarWidth);
            }
            else {
                $unorderedList.css("width", "");
            }
        };
        NavigationLists.centerListItem = function ($elementWithOverflow, $listItems, $selectedListItem) {
            ///<summary>scrolls the scrollable element so that, if possible, the selected item appears centered</summary>
            ///<param name="elementWidthOverflow">The jQuery object with the overflow: hidden style applied</param>
            ///<param name="listItems">The jQuery object for the unordered list's list items</param>
            ///<param name="selectedListItem">The jQuery object for the selected list item</param>
            var centerOfElementWithOverflow = $elementWithOverflow.outerWidth(true) / 2;
            var scrollToWidth = 0;
            for (var i = 0; i < $selectedListItem.index(); i++) {
                scrollToWidth += $($listItems[i]).outerWidth(true);
            }
            $elementWithOverflow.scrollLeft(scrollToWidth - centerOfElementWithOverflow + ($selectedListItem.outerWidth(true) / 2));
        };
        NavigationLists.handleScrollEvent = function ($elementWithOverflow, scrollbarWidth, elementWidth) {
            ///<summary>handles the scroll event an element</summary>
            ///<param name="elementWithOverflow">The jQuery object with the overflow: hidden style applied</param>
            var _this = this;
            $elementWithOverflow.scroll(function () {
                _this.handleArrows($elementWithOverflow, scrollbarWidth, elementWidth);
            });
        };
        NavigationLists.handleArrows = function ($elementWithOverflow, scrollbarWidth, elementWidth) {
            ///<summary>Hide or show the left and right arrows based on the scroll position</summary>
            ///<param name="elementWithOverflow">The jQuery object with the overflow: hidden style applied</param>
            ///<param name="scrollbarWidth">The width of the scrollbar</param>
            if ($elementWithOverflow.scrollLeft() > 30) {
                $("#leftArrow").addClass("left-arrow");
            }
            else {
                $("#leftArrow").removeClass("left-arrow");
            }
            var scrollMax = $elementWithOverflow.find("ul").width() - elementWidth - scrollbarWidth;
            if ($elementWithOverflow.scrollLeft() < scrollMax) {
                $("#rightArrow").addClass("right-arrow");
            }
            else {
                $("#rightArrow").removeClass("right-arrow");
            }
        };
        NavigationLists.registerRightArrowHandler = function ($elementWithOverflow, elementWidth) {
            ///<summary>register a handler for the click event on the right arrow</summary>
            ///<param name="elementWithOverflow">The jQuery object with the overflow: hidden style applied</param>
            $("#rightArrow").click(function () {
                var scrollAmount = $elementWithOverflow.scrollLeft() + elementWidth;
                $elementWithOverflow.scrollLeft(scrollAmount);
            });
        };
        NavigationLists.registerLeftArrowHandler = function ($elementWithOverflow, elementWidth) {
            ///<summary>register a handler for the click event on the left arrow</summary>
            ///<param name="elementWithOverflow">The jQuery object with the overflow: hidden style applied</param>
            var width = elementWidth;
            $("#leftArrow").click(function () {
                var scrollAmount = $elementWithOverflow.scrollLeft() - width;
                $elementWithOverflow.scrollLeft(scrollAmount);
            });
        };
        return NavigationLists;
    }());
    Cobalt.NavigationLists = NavigationLists;
})(Cobalt || (window.Cobalt = {}));


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.NavigationLists.js